import { gradients } from '/b2b/common/colors';

export const COMPLETE = 'COMPLETE';
export const COMPLETED = 'COMPLETED';
export const CLAIM = 'CLAIM';
export const UNCLAIM = 'UNCLAIM';
export const REOPEN = 'REOPEN';
export const REJECT = 'REJECT';
export const CLAIMED = 'CLAIMED';
export const IN_PROGRESS = 'IN_PROGRESS';
export const PENDING_DELETION = 'PENDING_DELETION';
export const REJECTED = 'REJECTED';
export const SEARCH_IN_PROGRESS = 'USER_DATA_SEARCH_IN_PROGRESS';
export const SEARCH_COMPLETED = 'USER_DATA_SEARCH_COMPLETED';

export const RESOLVED_ACTION_ITEM_STATUSES = [COMPLETE, COMPLETED, REJECTED];

export const ACTION_ITEM_ACTIONS = {
    COMPLETE,
    CLAIM,
    UNCLAIM,
    REOPEN,
    REJECT,
};

export const ACTION_ITEM_TYPES = {
    APPROVAL: 'APPROVAL',
    AUTOMATED: 'AUTOMATED',
    MANUAL: 'MANUAL',
};

export const ACTION_ITEM_STATUSES = {
    COMPLETED,
    CLAIMED,
    IN_PROGRESS,
};

export const COMPLETION_TYPE_AUTOMATION = 'AUTOMATION';
export const COMPLETION_TYPE_AUTOMATION_NO_RESULTS = 'AUTOMATION_NO_RESULTS';
export const COMPLETION_TYPE_MANUAL = 'MANUAL';
export const COMPLETION_TYPE_API_AUTOMATION = 'API_AUTOMATION';
export const COMPLETION_TYPE_NO_RESULTS = 'NO_RESULTS';

export const AUTOMATION_COMPLETION_TYPES = [
    COMPLETION_TYPE_AUTOMATION,
    COMPLETION_TYPE_AUTOMATION_NO_RESULTS,
];

export const MANUAL_COMPLETION_TYPES = [COMPLETION_TYPE_MANUAL, COMPLETION_TYPE_NO_RESULTS];

export const PROCESSING_TYPE_AUTOMATION = 'AUTOMATION';
export const PROCESSING_TYPE_MANUAL = 'MANUAL';

export const DSAR_SUMMARY_WRITE_STATUSES = {
    NONE: 'NONE',
    WRITE_ERROR: 'WRITE_ERROR',
    WRITTEN: 'WRITTEN',
};

export const DSAR_ACTION_ITEM_STATUS_KEYS = {
    UNASSIGNED: 'UNASSIGNED',
    ASSIGNED: 'ASSIGNED',
    IN_PROGRESS: 'IN_PROGRESS',
    CLAIMED: 'CLAIMED',
    COMPLETED: 'COMPLETED',
    PENDING_DELETION: 'PENDING_DELETION',
    REJECTED: 'REJECTED',
};

export const DSAR_ACTION_ITEM_STATUS = {
    [DSAR_ACTION_ITEM_STATUS_KEYS.ASSIGNED]: 'dsar.status.actionItem.assigned',
    [DSAR_ACTION_ITEM_STATUS_KEYS.CLAIMED]: 'dsar.status.actionItem.claimed',
    [DSAR_ACTION_ITEM_STATUS_KEYS.COMPLETED]: 'dsar.status.actionItem.completed',
    [DSAR_ACTION_ITEM_STATUS_KEYS.IN_PROGRESS]: 'dsar.status.actionItem.inProgress', // 'To Do' in the UI
    [DSAR_ACTION_ITEM_STATUS_KEYS.PENDING_DELETION]: 'dsar.status.actionItem.deletionInProgress',
    [DSAR_ACTION_ITEM_STATUS_KEYS.UNASSIGNED]: 'dsar.status.actionItem.unassigned',
    [DSAR_ACTION_ITEM_STATUS_KEYS.REJECTED]: 'dsar.status.actionItem.rejected',
};

export const DSAR_ACTION_ITEM_FILTER_STATUS_KEYS = {
    IN_PROGRESS: 'IN_PROGRESS',
    CLAIMED: 'CLAIMED',
    PENDING_DELETION: 'PENDING_DELETION',
    COMPLETED: 'COMPLETED',
    REJECTED: 'REJECTED',
};

export const DSAR_ACTION_ITEM_FILTER_STATUS = {
    [DSAR_ACTION_ITEM_FILTER_STATUS_KEYS.IN_PROGRESS]: 'dsar.status.actionItem.inProgress',
    [DSAR_ACTION_ITEM_FILTER_STATUS_KEYS.CLAIMED]: 'dsar.status.actionItem.claimed',
    [DSAR_ACTION_ITEM_FILTER_STATUS_KEYS.PENDING_DELETION]:
        'dsar.status.actionItem.deletionInProgress',
    [DSAR_ACTION_ITEM_FILTER_STATUS_KEYS.COMPLETED]: 'dsar.status.actionItem.completed',
    [DSAR_ACTION_ITEM_FILTER_STATUS_KEYS.REJECTED]: 'dsar.status.actionItem.rejected',
};

export const DSAR_ACTION_ITEM_COMPLETED_STATUS_KEYS = {
    NO_APPLICABLE_PRIVACY_LAW: 'NO_APPLICABLE_PRIVACY_LAW',
    OVERDUE: 'OVERDUE',
    WITHIN_REGULATORY_DATE: 'WITHIN_REGULATORY_DATE',
    WITHIN_INTERNAL_DATE: 'WITHIN_INTERNAL_DATE',
    UNKNOWN: 'UNKNOWN',
};

// This is only used for formatting the action item status for CSV (formatActionItemStatus)
export const DSAR_ACTION_ITEM_COMPLETED_STATUS = {
    [DSAR_ACTION_ITEM_COMPLETED_STATUS_KEYS.NO_APPLICABLE_PRIVACY_LAW]:
        'dsar.status.noApplicablePrivacyLaw',
    [DSAR_ACTION_ITEM_COMPLETED_STATUS_KEYS.OVERDUE]: 'dsar.status.overdue',
    [DSAR_ACTION_ITEM_COMPLETED_STATUS_KEYS.WITHIN_INTERNAL_DATE]: 'dsar.status.withinInternalDate',
    [DSAR_ACTION_ITEM_COMPLETED_STATUS_KEYS.WITHIN_REGULATORY_DATE]:
        'dsar.status.withinRegulatoryDate',
    [DSAR_ACTION_ITEM_COMPLETED_STATUS_KEYS.UNKNOWN]: 'dsar.status.unknown',
};

export const DSAR_ACTION_TO_TAKE_KEYS = {
    DELETE: 'DELETE',
    NOT_APPLICABLE: 'NOT_APPLICABLE',
    PROCESS_MANUALLY: 'PROCESS_MANUALLY',
    SUMMARIZE: 'SUMMARIZE',
    OPT_IN: 'OPT_IN',
    OPT_OUT: 'OPT_OUT',
};

export const DSAR_ACTION_TO_TAKE_NAMES = {
    [DSAR_ACTION_TO_TAKE_KEYS.SUMMARIZE]: 'dsar.requestActions.summarize',
    [DSAR_ACTION_TO_TAKE_KEYS.DELETE]: 'dsar.requestActions.delete',
    [DSAR_ACTION_TO_TAKE_KEYS.PROCESS_MANUALLY]: 'dsar.requestActions.processManually',
    [DSAR_ACTION_TO_TAKE_KEYS.OPT_IN]: 'dsar.requestActions.optIn',
    [DSAR_ACTION_TO_TAKE_KEYS.OPT_OUT]: 'dsar.requestActions.optOut',
};

export const DSAR_ACTION_PRESENT = {
    [DSAR_ACTION_TO_TAKE_KEYS.SUMMARIZE]: 'dsar.action.present.summarize',
    [DSAR_ACTION_TO_TAKE_KEYS.DELETE]: 'dsar.action.present.delete',
    [DSAR_ACTION_TO_TAKE_KEYS.PROCESS_MANUALLY]: 'dsar.action.present.manual',
    [DSAR_ACTION_TO_TAKE_KEYS.OPT_IN]: 'dsar.action.present.optIn',
    [DSAR_ACTION_TO_TAKE_KEYS.OPT_OUT]: 'dsar.action.present.optOut',
};

export const DSAR_ACTION_PAST = {
    [DSAR_ACTION_TO_TAKE_KEYS.SUMMARIZE]: 'dsar.action.past.summarize',
    [DSAR_ACTION_TO_TAKE_KEYS.DELETE]: 'dsar.action.past.delete',
    [DSAR_ACTION_TO_TAKE_KEYS.PROCESS_MANUALLY]: 'dsar.action.past.manual',
    [DSAR_ACTION_TO_TAKE_KEYS.OPT_IN]: 'dsar.action.past.optIn',
    [DSAR_ACTION_TO_TAKE_KEYS.OPT_OUT]: 'dsar.action.past.optOut',
};

export const EVENTS = {
    ACTION_ITEMS_FILTER: 'ActionItemsFilter',
    ACTION_ITEMS_SEARCH: 'ActionItemsSearch',
};

export const ACTION_TO_TAKE_COLOR_MAPPINGS = {
    [DSAR_ACTION_TO_TAKE_KEYS.DELETE]: gradients.error,
    [DSAR_ACTION_TO_TAKE_KEYS.PROCESS_MANUALLY]: gradients.warning,
    [DSAR_ACTION_TO_TAKE_KEYS.SUMMARIZE]: gradients.purple,
    [DSAR_ACTION_TO_TAKE_KEYS.NOT_APPLICABLE]: gradients.grey,
    [DSAR_ACTION_TO_TAKE_KEYS.OPT_IN]: gradients.success,
    [DSAR_ACTION_TO_TAKE_KEYS.OPT_OUT]: gradients.success,
};
